import { useContext, useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import leftIcon from "resources/img/puffu/left.png";
import rightIcon from "resources/img/puffu/right.png";
import DummyCard from "routes/front/main/DummyCard";
import { ShoppingProcessType } from "shared/constants/constants";
// import { useCategory } from "../../process/category/CategoryContext";
import Pagination from "../../process/pagination/Pagination";
import CategoryButtons from "../../process/category/CategoryButtons";
import ProductCard from "../../process/card/ProductCard";
import SoldOutProductCard from "../../process/card/SoldOutProductCard";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useSelector, useDispatch } from "react-redux";
import { useTouchClick } from "shared/hooks/useTouchClick";
import HorizontalPagination from "../../process/pagination/HorizontalPagination";
import { setSelectedProductCategory, setSelectedSubCategoryId, resetCategoryState } from '../../process/category/CategoryReducer';
import { toggleDropdown, closeDropdown, setCurrentSortOption } from '../../process/category/SortingDropdownReducer';
import SkeletonProductCard from "../../process/card/SkeletonProductCard";
import style from "./HorizontalAddtoCartStep.module.css";
import SlideGuide from "./SlideGuide";




function HorizontalAddtoCartStep(props) {
    const { id } = useParams();
    const { isMobile } = useContext(BrowserDetectContext);
    const { viewData, setViewData, filteredProducts, currentPage, setCurrentPage, selectedCategory, subCategories, onPageChange, pagingData, fetchProductData } = useOutletContext();
    const [productCategories, setProductCategories] = useState([]);
    const { currentSortOption, sortingOptions } = useSelector((state) => state.sortingDropdown);
    const { selectedProductCategory, selectedSubCategoryId } = useSelector((state) => state.category);
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);
    const itemsPerPage = 10;
    const currentProcess = ShoppingProcessType.CART;
    const skeletonCount = 10;
    const { isLoading } = useSelector((state) => ({
        isLoading: state.history.isLoading
    }));

    useEffect(() => {
        let data = {
            title: "",
            footterButtonText: "",
            currentProcess: currentProcess,
            totalCount: 0,
            selectedCount: 0,
            priceSum: 0,
            vat: 0,
            deliveryFee: 0,
            discountSum: 0,
            totalAmount: 0,
            onDeleteSelectedProductsClick: () => { },
            onSubmitButtonClick: () => { },
            detailYn: false,
            detailProduct: null,
            slideGuide: true
        };
        setViewData((prevData) => {
            return {
                ...prevData,
                currentProcess: currentProcess
            };
        });

        setMounted(true);

    }, []);
    useEffect(() => {
        if (isMounted) {
            const timer = setTimeout(() => {
                setViewData((prevData) => ({
                    ...prevData,
                    slideGuide: false
                }));
            }, 4000);
            return () => clearTimeout(timer);
        }



    }, [isMounted])



    const totalProducts = filteredProducts.length;
    const totalPages = Math.ceil(totalProducts / itemsPerPage);

    useEffect(() => {
        if (totalPages === 0 && currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);

    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const currentItems = filteredProducts.slice(startIndex, startIndex + itemsPerPage);

        if (currentItems.length < itemsPerPage) {
            const dummyCount = itemsPerPage - currentItems.length;
            const dummyElements = Array.from({ length: dummyCount }).map((_, index) => (

                <div key={`dummy-${index}`} style={{ display: "flex", flex: "1 0 17%", opacity: 0 }}>
                    <SkeletonProductCard data={{}} />
                </div>
            ));
            return currentItems.concat(dummyElements);
        }

        return currentItems;
    };

    const handleProductCategorySelect = (category) => {
        // 정렬 옵션으로 카테고리를 선택한 경우
        if (sortingOptions.includes(category)) {
            fetchProductData(selectedSubCategoryId || selectedCategory, 0, category);
            setCurrentPage(1);
            return;
        }

        // 이미 선택된 카테고리를 다시 선택한 경우 (선택 해제)
        if (selectedProductCategory === category) {
            dispatch(resetCategoryState());
            fetchProductData(selectedCategory, 0, currentSortOption);
        } else {
            // 새로운 카테고리를 선택한 경우
            dispatch(setSelectedProductCategory(category));
            const subCategoryId = subCategories.find(sc => sc.categoryName === category)?.id;
            dispatch(setSelectedSubCategoryId(subCategoryId));
            fetchProductData(subCategoryId, 0, currentSortOption);

        }

        setCurrentPage(1);
    };


    const handleSlide = (deltaX) => {
        if (deltaX > 0 && pagingData.hasNext) {
            onPageChange('next');
        } else if (deltaX < 0 && pagingData.hasPrevious) {
            onPageChange('prev');
        }
    };

    const { handleTouchStart, handleTouchEnd } = useTouchClick(
        null,
        50,
        (deltaX) => handleSlide(deltaX),
        true
    );

    useEffect(() => {
        if (selectedCategory === 'all') {
            setProductCategories([]);
        } else {
            const filteredSubCategories = subCategories.filter(
                (subCategory) => subCategory.parentCategoryId === selectedCategory
            );
            const newProductCategories = filteredSubCategories.map(
                (subCategory) => subCategory.categoryName
            );
            setProductCategories(newProductCategories);
        }
    }, [selectedCategory, subCategories]);


    return (

        <div style={{ width: "100%", height: "100%", position: "relative", justifyContent: "center", display: "flex" }}>
            {
                !isLoading && viewData.slideGuide
                &&
                <div style={{ position: "absolute", top: "40%", left: "37%", width: "max-content", zIndex: 999 }}>
                    <SlideGuide setViewData={setViewData} />
                </div>
            }

            <HorizontalPagination
                pagingData={pagingData}
                onPageChange={onPageChange}
                leftIcon={leftIcon}
                rightIcon={rightIcon}
                bottom='-20.3vh'
            />

            <div style={{ position: 'absolute', top: '30px', width: '93%' }}>
                <CategoryButtons
                    categories={productCategories}
                    selectedProductCategory={selectedProductCategory}
                    onCategorySelect={handleProductCategorySelect}

                />
            </div>
            <div
                onPointerDown={handleTouchStart}
                onPointerUp={handleTouchEnd}
                style={{
                    width: "93%",
                    height: "58.5vh",
                    display: "flex",
                    transform: "translate(0, 45px)",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "15px",
                    // padding: "0 15px 10px 15px",
                    // overflow: "auto",
                    marginTop: '60px' // Ensure there is space for the pagination controls
                }}
            >
                {isLoading ? (
                    // 로딩 중일 때 스켈레톤 표시
                    Array.from({ length: skeletonCount }).map((_, index) => (
                        <SkeletonProductCard key={index} flex={"1 0 17%"} />
                    ))
                ) : (
                    // 로딩이 완료되면 실제 상품 표시
                    getCurrentPageItems().map((data, index) => {
                        return data.productName ? (
                            data.quantity > 0
                                ? <ProductCard flex={"1 0 17%"} data={data} key={index} setViewData={setViewData} />
                                : <SoldOutProductCard data={data} realQuantity={data.quantity} key={index} setViewData={setViewData} flex={"1 0 17%"} />
                        ) : data;
                    })
                )}
            </div>
        </div>
    );
}

export default HorizontalAddtoCartStep;